import React, {useLayoutEffect, useState} from "react";
import {Popconfirm, Tooltip} from "antd";
import {EditOutlined, DeleteOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TableContainer, ActionButtons} from "./ResponsiveDataTable.styles";
import {useHistory} from "react-router-dom";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import moment from "moment";
import {useStore} from "../../../../hooks/useStore";
import {UpdateEquipmentTypeModal} from "../modals/updateEquipmentTypeModal/UpdateEquipmentTypeModal";

const TABLE_PREFIX = "equipmentTypesTable";
const ResponsiveDataTable = ({
    data,
    loading,
    currentPage,
    setCurrentPage,
    dataCount,
    recall = () => {}
}) => {
    const {t} = useTranslation();
    const history = useHistory();
    const stores = useStore();
    const [selectedRow, setSelectedRow] = useState(null);
    const [showUpdateEquipmentTypeModal, setShowUpdateEquipmentTypeModal] = useState(false);

    const openUpdateEquipmentTypeModal = () => {
        setShowUpdateEquipmentTypeModal(true);
    };
    const closeUpdateEquipmentTypeModal = () => {
        setShowUpdateEquipmentTypeModal(false);
    };

    const onClickUpdateButton = id => {
        const selectedItem = data.find(item => item?._id === id);
        setSelectedRow(selectedItem);
        openUpdateEquipmentTypeModal();
    };

    const handleRemove = async ({id}) => {
        try {
            const response = await stores.equipmentStore.deleteEquipmentType({id});
            if (response) {
                recall();
            }
        } catch (e) {
            console.log(e);
        }
    };
    const renderActionButtons = id => {
        const permisions = {
            edit: true,
            delete: true
        };
        return (
            <ActionButtons>
                {permisions.edit && (
                    <Tooltip title={t("actions.edit", {ns: "common"})}>
                        <CustomButton
                            data-testid="editButton"
                            onClick={() => onClickUpdateButton(id)}
                            icon={<EditOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
                {permisions.delete && (
                    <Tooltip title={t("actions.delete", {ns: "common"})} placement="bottom">
                        <Popconfirm
                            title={t("modal.confirmTitle", {ns: "common"})}
                            open={open}
                            onConfirm={() => handleRemove({id})}
                            onCancel={() => setOpen(false)}
                            okText={t("modal.yesButton", {ns: "common"})}
                            cancelText={t("modal.noButton", {ns: "common"})}
                        >
                            <CustomButton
                                data-testid="deleteButton"
                                icon={<DeleteOutlined />}
                            ></CustomButton>
                        </Popconfirm>
                    </Tooltip>
                )}
            </ActionButtons>
        );
    };

    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                pagination={
                    false /* {
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                } */
                }
                rowKey="_id"
                rowClassName="hello"
                dataSource={data}
                data-testid="dataTable"
                loading={loading}
            >
                <TableContainer.Column
                    dataIndex="name"
                    title={"Ekipman Tipi"}
                    render={name => (
                        <span data-testid="name" data-label={`Ekipman Tipi:`}>
                            {name}
                        </span>
                    )}
                    sorter={(a, b) => a?.name?.localeCompare(b?.name, "tr")}
                    defaultSortOrder={"ascend"}
                />
                <TableContainer.Column
                    dataIndex="createdAt"
                    title={"Oluşturulma Tarihi"}
                    sorter={(a, b) => moment(a.createdAt).diff(moment(b.createdAt))}
                    render={createdAt => (
                        <span data-testid="createdAt" data-label={`Oluşturulma Tarihi:`}>
                            {createdAt ? moment(createdAt).format("DD.MM.YYYY HH:mm") : "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="updatedAt"
                    title={"Son Güncellenme Tarihi"}
                    render={(updatedAt, record) => (
                        <span data-testid="updatedAt" data-label={`Son Güncellenme Tarihi:`}>
                            {updatedAt
                                ? moment(updatedAt).format("DD.MM.YYYY HH:mm")
                                : record?.createdAt
                                ? moment(record.createdAt).format("DD.MM.YYYY HH:mm")
                                : "-"}
                        </span>
                    )}
                />
                <TableContainer.Column
                    align="right"
                    title={t("actions.action", {ns: "common"})}
                    dataIndex="_id"
                    render={renderActionButtons}
                />
            </TableContainer>
            {/* Modals */}
            <UpdateEquipmentTypeModal
                visibility={showUpdateEquipmentTypeModal}
                equipmentType={selectedRow}
                recall={recall}
                changeVisibility={setShowUpdateEquipmentTypeModal}
                onCancel={closeUpdateEquipmentTypeModal}
                onOk={closeUpdateEquipmentTypeModal}
            />
        </>
    );
};

export default ResponsiveDataTable;
